<template>
  <div class="clients">
    <div class="clients-list panel list-panel">
      <el-container>
        <el-header class="clearfix">
          <h2 class="card-title">Clients</h2>
          <el-radio-group v-model="groupBy" size="mini" style="margin-left: 20px;">
            <el-radio-button label="Created At"></el-radio-button>
            <el-radio-button label="A-Z"></el-radio-button>
          </el-radio-group>
          <el-checkbox-group v-model="statusFilter" size="mini" class="status-filter">
            <el-checkbox-button label="prospect" key="prospect" @change="setLastFilterStatus('prospect')">Onboarding</el-checkbox-button>
            <el-checkbox-button label="client" key="client" @change="setLastFilterStatus('client')">Client</el-checkbox-button>
            <el-checkbox-button label="archived" key="archived" @change="setLastFilterStatus('archived')">Archived</el-checkbox-button>
          </el-checkbox-group>
          <el-button class="header-btn pull-right"
                     type="primary"
                     icon="el-icon-circle-plus"
                     @click="createClient"> Create New Client</el-button>
          <div class="search-bar pull-right">
            <el-input placeholder="Search..." v-model="searchTerm" />
          </div>
        </el-header>
        <el-main>
          <el-card class="box-card"
                   :key="key"
                   v-for="(clients, key) in clientsFiltered">
            <div slot="header" class="clearfix">
              <span><b>{{ key }}</b></span>
            </div>
            <div class="list-group">
              <el-button plain
                         :key="client.id"
                         v-for="client in clients"
                         @click="gotoClient(client)"
                         class="client-list-item list-item" :class="{ prospect: !!client.prospect }">
                <div class="list-item-btn">
                  <client-code v-if="!client.icon" :code="client.code" :seed="client.name" />
                  <img v-if="client.icon" :src="client.icon_url" class="client-code"/>
                  <div class="info">
                    <div class="title"><b>{{ client.name }}</b></div>
                    <div class="created-at">Created {{ client.created_at | localiseUTCDate }} by {{ client.user_full_name }}</div>
                  </div>
                  <el-tag v-if="client.prospect" size="small" type="info" class="type pull-right">Onboarding</el-tag>
                  <el-tag v-if="client.archived" size="small" type="danger" class="type pull-right">Archived</el-tag>
                  <i class="el-icon-caret-right pull-right icon" />
                </div>
              </el-button>
            </div>
          </el-card>
          <el-card class="box-card" v-if="!Object.keys(clientsFiltered).length">
            <div slot="header" class="clearfix">
              <span><b>No Clients Found!</b></span>
            </div>
          </el-card>
        </el-main>
      </el-container>
    </div>
    <client-crud v-if="showClientCrud"
                 @close="clientCrudClose" />
  </div>
</template>

<script>
  import moment from 'moment'
  import { mixin as Utils } from '../../mixins/Utils'
  export default {
    name: 'clients',
    mixins: [Utils],
    data () {
      return {
        showClientCrud: false,
        searchTerm: '',
        groupBy: 'Created At',
        statusFilter: [],
        lastFilterStatus: null
      }
    },
    methods: {
      createClient () {
        this.showClientCrud = true
      },
      clientCrudClose (client) {
        // Handle the Client Crud Dialog closing
        if (client) {
          this.$router.push({name: 'client', params: { client_id: client.id }})
        }
        this.showClientCrud = false
      },
      setLastFilterStatus (status) {
        this.lastFilterStatus = status
      },
      gotoClient (client) {
        this.$router.push({name: 'client', params: { client_id: client.id }})
      }
    },
    computed: {
      // Vuex Mappings
      clients () {
        return Object.keys(this.$store.state.clients.objects)
        .map((k) => this.$store.state.clients.objects[k])
        .sort((a, b) => {
          return (Date.parse(a.created_at) < Date.parse(b.created_at)) ? 1 : -1
        })
      },
      currentUser () {
        return this.$store.state.users.currentUser
      },
      clientsFiltered () {
        // First filter the clients by the search param
        let clients = this.clients.filter((client) => {
          if (this.searchTerm !== '') {
            if (client.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              client.code.toLowerCase().includes(this.searchTerm.toLowerCase())) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        })

        // Now group the results into 'sort by' categories..
        let optionsObj = {}

        let groupBy = this.$store.state.filters.clientsGroupBy // Store will be updated via vuex in watcher
        let statusFilter = this.$store.state.filters.clientsStatusFilter // Store will be updated via vuex in watcher
        let showOnboarding = statusFilter.indexOf('prospect') !== -1
        let showClient = statusFilter.indexOf('client') !== -1
        let showArchived = statusFilter.indexOf('archived') !== -1

        // Group Projects by the select sort type
        Object.keys(clients)
          .map((k) => clients[k])
          .sort((a, b) => {
            if (groupBy === 'A-Z') {
              return a.name > b.name ? 1 : -1
            } else {
              // Default - Created At
              return a.created_at > b.created_at ? -1 : 1
            }
          })
          .map((item) => {
            if ((!showOnboarding && !showClient && !showArchived) ||
              (showOnboarding && item.prospect) ||
              (showClient && !item.prospect) ||
              (showArchived && item.archived)) {
              let groupLabel = null
              if (groupBy === 'A-Z') {
                groupLabel = item.name.substring(0, 1).toUpperCase()
              } else {
                // Default - Created At
                groupLabel = moment(item.created_at).format('MMM YYYY')
              }

              // Dimension the array if it does not yet exist
              if (!optionsObj.hasOwnProperty(groupLabel)) {
                optionsObj[groupLabel] = []
              }
              optionsObj[groupLabel].push(item)
            }
          })
        // Finally, sort the sub groups by title
        for (let groupLabel in optionsObj) {
          optionsObj[groupLabel] = optionsObj[groupLabel].sort((a, b) => {
            if (groupBy === 'A-Z') {
              return a.name > b.name ? 1 : -1
            } else {
              return a.created_at > b.created_at ? -1 : 1
            }
          })
        }
        return optionsObj
      }
    },
    watch: {
      groupBy () {
        this.$store.dispatch('setClientsGroupBy', this.groupBy)
      },
      statusFilter () {
        // Toggle the Status Filter buttons (prevent multiple from being selected)

        // If the change in status filter caused more than 1 element to be selected
        // we need to remove everything other than the last selected item
        if (this.statusFilter.length > 1) {
          this.statusFilter = [this.lastFilterStatus]
        }

        this.$store.dispatch('setClientsStatusFilter', this.statusFilter)
      }
    },
    mounted () {
      this.$store.dispatch('setPageTitle', 'Clients')
      setTimeout(() => {
        this.$store.dispatch('getClients')
      })

      this.groupBy = this.$store.state.filters.clientsGroupBy
      this.statusFilter = this.$store.state.filters.clientsStatusFilter
    }
  }
</script>
<style lang="less" rel="stylesheet/less" scoped>
  .client-list-item {
    &.prospect {

    }
    .type {
      margin-right: 10px;
    }
  }
  .status-filter,
  .group-by {
    margin-left: 20px;
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
  }
</style>
